import React from 'react';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import { SettingsProvider, PackagesProvider } from './store';
import Home from './pages/Home';
import PackageDetail from './pages/PackageDetail';
import SearchResults from './pages/SearchResults';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BlogList from './pages/BlogList';
import BlogDetail from './pages/BlogDetail';
import CollectionPage from './pages/CollectionPage';
import StaticPageView from './pages/StaticPageView';
import LandingPageView from './pages/LandingPageView';
import OffersPage from './pages/OffersPage';
import FloatingActions from './components/FloatingActions';
import ChatWidget from './components/ChatWidget';
import CookieBar from './components/CookieBar';
import ScrollToTop from './components/ScrollToTop';
import './App.css';

// Hide public overlays (chat, floating actions, cookie bar) on admin routes
const PublicOverlays = () => {
  const loc = useLocation();
  if (loc.pathname.startsWith('/admin')) return null;
  return (
    <>
      <FloatingActions />
      <ChatWidget />
      <CookieBar />
    </>
  );
};

function App() {
  return (
    <div className="min-h-screen bg-white">
      <BrowserRouter>
        <ScrollToTop />
        <SettingsProvider>
          <PackagesProvider>
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/package/:id" element={<PackageDetail />} />
              <Route path="/search" element={<SearchResults />} />
              <Route path="/offers" element={<OffersPage />} />
              <Route path="/blog" element={<BlogList />} />
              <Route path="/blog/:slug" element={<BlogDetail />} />
              <Route path="/destination/:slug" element={<CollectionPage kind="destination" />} />
              <Route path="/theme/:slug" element={<CollectionPage kind="theme" />} />
              <Route path="/page/:slug" element={<StaticPageView />} />
              <Route path="/p/:slug" element={<LandingPageView />} />
              <Route path="/admin" element={<AdminLogin />} />
              <Route path="/admin/dashboard" element={<AdminDashboard />} />
            </Routes>
            <PublicOverlays />
          </PackagesProvider>
        </SettingsProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
